module.exports = __webpack_public_path__ + "img/Nenter.a82988d3.jpeg";